import JobApplicationPositionRequirements from './PositionRequirements.component';

export default JobApplicationPositionRequirements;
